import { render } from "./Inventario.vue?vue&type=template&id=42b3d98a&scoped=true"
const script = {}

import "./Inventario.vue?vue&type=style&index=0&id=42b3d98a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b3d98a"]])

export default __exports__